import type { FeatureFlagHeaderMap, Locale } from 'corgi-types';
import { FeatureFlagHeader } from 'corgi-types';
import type { DocumentNode } from 'graphql';
import { print } from 'graphql';
import type { GQLLocale } from 'graphql-ts-types';

export const toGQLUrlParams = (query: string) => (query.startsWith('?') ? query.slice(1) : query);

const STAGING_GRAPHQL_ENDPOINT_URL = 'https://staging-internal.graphql.app.home24.net/query';
const SANDBOX_1_GRAPHQL_ENDPOINT_URL = 'https://sandbox-1-internal.graphql.app.home24.net/query';
const SANDBOX_2_GRAPHQL_ENDPOINT_URL = 'https://sandbox-2-internal.graphql.app.home24.net/query';

enum GQLSandbox {
  One = '1',
  Two = '2',
}

export const getGQLClientUri = (uri: string, featureFlags: FeatureFlagHeaderMap) => {
  if (uri === STAGING_GRAPHQL_ENDPOINT_URL) {
    const sandbox = featureFlags[FeatureFlagHeader.Sandbox];
    if (sandbox === GQLSandbox.One) {
      return SANDBOX_1_GRAPHQL_ENDPOINT_URL;
    }
    if (sandbox === GQLSandbox.Two) {
      return SANDBOX_2_GRAPHQL_ENDPOINT_URL;
    }
  }
  return uri;
};

export const getGQLQueryLog = (query: DocumentNode) => {
  const logQuery = print(query).replace(/[\n\s]+/g, ' ');

  return `GQL_SERVER_LOG ${logQuery}`;
};

export const toGQLLocale = (locale: Locale): GQLLocale => locale as unknown as GQLLocale;
